import { Variables } from 'react-relay';
import {
  Environment,
  Network,
  RecordSource,
  Store,
  GraphQLResponse,
  RequestParameters,
} from 'relay-runtime';
import { post } from './ajax';
import { mockNetworkHandler } from '../../mockRelay/mockNetworkHandler';

const { REACT_APP_UPP_GRAPHQL_URL, REACT_APP_USE_MOCK_NETWORK_HANDLER } =
  process.env;

const callGraphql = async (
  params: RequestParameters,
  variables: Variables,
): Promise<GraphQLResponse> => {
  try {
    const response = await post(
      REACT_APP_UPP_GRAPHQL_URL as string,
      {
        query: params.text,
        variables,
      },
      {
        credentials: 'include',
      },
    );

    // GraphQL returns exceptions (for example, a missing required variable) in the "errors"
    // property of the response. If any exceptions occurred when processing the request,
    // throw an error to indicate to the developer what went wrong.
    if (Array.isArray(response.errors)) {
      console.error(
        `Error fetching GraphQL query '${
          params.name
        }' with variables '${JSON.stringify(variables)}'`,
      );
      const errorMessages: string = response.errors
        .map(
          (error: Error, index: number) => `Error ${index}: ${error.message}`,
        )
        .join('\n');
      console.error(`All error messages: \n${errorMessages}`);
      console.error(`All error details: ${JSON.stringify(response.errors)}`);
      throw new Error(errorMessages);
    }
    return response;
  } catch (e: Error | unknown) {
    console.log('Error fetching graphql request', e as Error);
    //throw e;
    return {
      errors: [e as Error],
    };
  }
};

// Conditionally use the mock network handler based on the environment variable
const network = Network.create(
  REACT_APP_USE_MOCK_NETWORK_HANDLER === 'true'
    ? mockNetworkHandler
    : callGraphql,
);

// Export a singleton instance of Relay Environment configured with our network layer:
export const environment = new Environment({
  network,
  store: new Store(new RecordSource(), {
    // This property tells Relay to not immediately clear its cache when the user
    // navigates around the app. Relay will hold onto the specified number of
    // query results, allowing the user to return to recently visited pages
    // and reusing cached data if its available/fresh.
    gcReleaseBufferSize: 10,
  }),
});
